var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2001 6.76404H8.44409V34H29.2001V6.76404Z",
    fill: "#A3CFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8081 13.888H13.8361C13.5041 13.888 13.2361 13.62 13.2361 13.288C13.2361 12.956 13.5041 12.688 13.8361 12.688H23.8081C24.1401 12.688 24.4081 12.956 24.4081 13.288C24.4081 13.62 24.1401 13.888 23.8081 13.888Z",
    fill: "#4C66D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8081 18.656H13.8361C13.5041 18.656 13.2361 18.388 13.2361 18.056C13.2361 17.724 13.5041 17.456 13.8361 17.456H23.8081C24.1401 17.456 24.4081 17.724 24.4081 18.056C24.4081 18.388 24.1401 18.656 23.8081 18.656Z",
    fill: "#4C66D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8081 23.424H13.8361C13.5041 23.424 13.2361 23.156 13.2361 22.824C13.2361 22.492 13.5041 22.224 13.8361 22.224H23.8081C24.1401 22.224 24.4081 22.492 24.4081 22.824C24.4081 23.156 24.1401 23.424 23.8081 23.424Z",
    fill: "#4C66D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8081 28.196H13.8361C13.5041 28.196 13.2361 27.928 13.2361 27.596C13.2361 27.264 13.5041 26.996 13.8361 26.996H23.8081C24.1401 26.996 24.4081 27.264 24.4081 27.596C24.4081 27.928 24.1401 28.196 23.8081 28.196Z",
    fill: "#4C66D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3603 12.42C38.2603 11.52 38.2603 10.056 37.3603 9.15602C36.4603 8.25602 34.9963 8.25602 34.0963 9.15602L34.0923 9.15202L33.2763 9.96802L36.5443 13.236L35.7283 14.052L32.4603 10.784L23.1803 20.064L22.7363 20.508L26.0043 23.776L35.7243 14.056L37.3603 12.42Z",
    fill: "#4C66D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2801 9.96915L32.4626 10.7866L35.7323 14.0562L36.5497 13.2388L33.2801 9.96915Z",
    fill: "#CFE4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5442 24.976L21.9002 23.64L22.8762 24.616L21.7722 24.912L21.5442 24.976L26.0082 23.78L22.7402 20.508L21.5442 24.976Z",
    fill: "#CFE4FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7723 24.912L22.8763 24.616L21.9003 23.64L21.6043 24.744C21.5763 24.848 21.6723 24.94 21.7723 24.912Z",
    fill: "#4C66D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalBlue);
export default __webpack_public_path__ + "static/media/journal_blue.b40f592b9bdf1175e6a43a578ec754e6.svg";
export { ForwardRef as ReactComponent };